export const useJsonLdSchema = () => {
    const config = useRuntimeConfig();
    const route = useRoute();

    // Base schema for all pages
    const baseSchema = {
        type: 'application/ld+json',
        children: JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "WebSite",
            "name": "SK Jewellery",
            "url": config.public.BASE_URL,
            "potentialAction": {
                "@type": "SearchAction",
                "target": `${config.public.BASE_URL}?s={search_term_string}`,
                "query-input": "required name=search_term_string"
            }
        })
    };

    // Array of schemas to include
    const schemas = [baseSchema];

    // Only add the second schema if we're on the homepage
    if (route.path === '/' || route.path === '') {
        schemas.push({
            type: 'application/ld+json',
            children: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "WebSite",
                "name": "You Deserve To Shine | SK Jewellery",
                "alternateName": "SK Jewellery",
                "description": "Staying true to the brand's belief that everyone deserves to shine, each piece of jewellery is meaningfully conceptualised and beautifully crafted.",
                "url": config.public.BASE_URL
            })
        });
    }

    // Add the schemas to the head
    useHead({
        script: schemas
    });
}